import { ETyresCarType } from "@tm/models"

export const SpecialCarTypes = [ETyresCarType.Agrar, ETyresCarType.EM, ETyresCarType.Industrie, ETyresCarType.Militar]
